module.exports = __webpack_public_path__ + "static/media/seadata-team.aad68d8d.webp";